import React from "react";
import PropTypes from "prop-types";

const SearchBox = ({handleChange, searchText}) => {

    return (
        <div>
            <label htmlFor="search" className="sr-only block text-sm font-medium text-gray-700">Search search terms</label>
            <div className="mt-2 mb-7 flex rounded-md shadow">
            <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd" />
                </svg>
                </div>
                <input id="search" type="text" value={searchText} onChange={handleChange} className= "focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300" />
            </div>
            <button className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                <span>Search</span>
            </button>
            </div>
        </div>
    )
}

export default SearchBox;